function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M.213 1.61L5.99 9v5a2.01 2.01 0 004.02 0V9s3.446-4.41 5.778-7.39C16.3.95 15.828 0 14.984 0H1.006C.172 0-.3.95.213 1.61z"
});
function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#BFB7B6"
  }, props), _ref);
}
export default SvgFilter;